import axios from "axios";
import { normalize, DEFAULT_CONTENT } from "./content";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, withCredentials: true });

export const fetchContent = async () => {
  if (!BASE) return normalize(DEFAULT_CONTENT);
  try {
    const { data } = await api.get("/content");
    return normalize(data);
  } catch {
    return normalize(DEFAULT_CONTENT);
  }
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.url;
};

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
};
